<template>
  <section>
    <BasicVideoPicsTextSwiper :title="title" :subtitle="subtitle" :imgs="imgs" id="10"></BasicVideoPicsTextSwiper>
  </section>
</template>
<script>
import BasicVideoPicsTextSwiper from '@/components/basic-videopicstext-swiper-new.vue'
export default {
  data() {
    return {
      title: '多样路况中皆能提供精准、平稳的辅助',
      subtitle: '成就一路安然笃行的自信',
      imgs: [
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/fca2pc.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/fca2mob.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: 'FCA2 前方防止碰撞辅助 II',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/hda2pc.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/hda2mob.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: 'HDA2 高速公路驾驶辅助 II',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/pdwpc.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/pdwmob.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'PDW-F/S/R 泊车距离警告-前方/侧方/后方',
         // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/rspapc.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/rspamob.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'RSPA 遥控智能泊车辅助',
         // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/svmpc.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/svmmob.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'SVM 全景显示(+侧后方影像)',
          //text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/lfapc.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/lfamob.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'LFA2 车道保持辅助 II(带离手监测)',
          // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/ifspc.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/ifsmob.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'IFS 智能前大灯功能',
          // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/aqqnpc.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/new-sportage/drive/aqqnmob.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '全系标配6安全气囊',
          // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        }
      ],
    }
  },
  components: {
    BasicVideoPicsTextSwiper
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>



</style>
